import { UiSchema } from '@rjsf/utils'
import { omit, cloneDeep } from 'lodash'
import { NlpIntent } from '@feedyou-ai/feedbot-schema'
import botSchema from '@feedyou-ai/feedbot-schema/schema/botFlow.json'

import { SettingsPopupOpenSection } from '../../../store/modals'

type HiddenIntentProps = keyof Pick<NlpIntent, 'rules' | 'dialog' | 'variables' | 'utterances'>
const HIDDEN_INTENT_PROPERTIES: HiddenIntentProps[] = ['rules', 'dialog', 'variables', 'utterances']

export function getSchema() {
  return cloneDeep(botSchema?.definitions?.nlpIntent) || {}
}

export function getFormData(intent: NlpIntent | undefined, openSection: SettingsPopupOpenSection) {
  return openSection === 'form' ? intent || {} : omit(intent, ['id', ...HIDDEN_INTENT_PROPERTIES])
}

export function getUiSchema(): UiSchema {
  const uiSchema: UiSchema = {}
  const hidden = { 'ui:widget': 'hidden' }
  const readonly = { 'ui:readonly': true }

  HIDDEN_INTENT_PROPERTIES.forEach(key => {
    uiSchema[key] = hidden
  })

  return { ...uiSchema, id: readonly }
}
